window.trans = function(key, replace = {})
{
    const [file, ...remainingKey] = key.split('.');
    const joinedKey = remainingKey.join('.');

    let translation = window.translations[file][joinedKey] || null;

    for (var placeholder in replace) {
        translation = translation.replace(`:${placeholder}`, replace[placeholder]);
    }

    return translation;
}